import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as BsTooltip } from 'bootstrap';
import { cloneElement, isValidElement, useEffect, useRef, } from 'react';
import { createRoot } from 'react-dom/client';
export const Tooltip = (props) => {
    const childRef = useRef(null);
    useEffect(() => {
        var _a;
        if (childRef.current) {
            const title = isValidElement(props.title)
                ? convertJsxToDomElement(props.title)
                : props.title;
            const t = new BsTooltip(childRef.current, {
                title: title,
                placement: (_a = props.placement) !== null && _a !== void 0 ? _a : 'top',
                trigger: 'hover focus',
                html: true,
            });
            return () => t.dispose();
        }
    }, [props.title, props.placement]);
    if (props.useWrapper) {
        return _jsx("div", { ref: childRef, children: props.children });
    }
    return cloneElement(props.children, { ref: childRef });
};
const convertJsxToDomElement = (jsx) => {
    const container = document.createElement('div');
    const root = createRoot(container);
    root.render(jsx);
    return container;
};
